import { formatClaimDeadline } from "@/services/claim-window";

interface IProps {
  deadline: number | null;
  className?: string;
}

const ClaimClosedNotice = ({ deadline, className = "" }: IProps) => {
  const formattedDeadline = formatClaimDeadline(deadline);

  return (
    <div
      className={`w-full border border-[#5A2A2A] bg-[#2A1416] px-4 py-3 font-gilroy-regular text-sm text-[#FF9A93] ${className}`}
    >
      <span className="font-semibold text-white">
        The claim period has ended
        {formattedDeadline ? ` on ${formattedDeadline}` : ""}.
      </span>{" "}
      SPON can no longer be claimed from this contract, so any claim transaction
      will be rejected on-chain.
    </div>
  );
};

export default ClaimClosedNotice;
